import React, { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { IHeaderMenuPropsDefault } from './types';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import Text from 'antd/lib/typography/Text';

const useStyles = makeStyles(({ colors, spacing }) => ({
  back: {
    padding: `${spacing(1)}px 20px`,
    cursor: 'pointer',
    color: colors.greyRaven
  },
  paper: {
    width: '100%'
  }
}));

const Mobile: FC<IHeaderMenuPropsDefault> = ({ children, onClose, open }) => {
  const classes = useStyles();

  return (
    <Drawer
      placement={'right'}
      closable={false}
      onClose={onClose}
      open={open}
      key={'right'}
      className={classes.paper}
    >
      <Box className={classes.back} display="flex" alignItems="center" onClick={onClose}>
        <ArrowLeftOutlined size={6} />
        <Text>Назад</Text>
      </Box>
      {children}
    </Drawer>
  );
};

export default Mobile;
